import { Icons, Progress, Spinner, Text } from '@agro-club/agroclub-shared'
import { FC, useRef } from 'react'
import { DocumentFile, RespFile } from 'modules/domain/types'
import {
  AddBtn,
  AddFileIcon,
  FilePlaceholder,
  FileWrapper,
  IconContainer,
  ImagesWrapper,
  NumberContainer,
} from './styled'

type Props = {
  selectedFiles: number[]
  docs: DocumentFile[] | RespFile[]
  onUpload?: (files: FileList) => unknown
  uploadProgress?: Progress
  onDocClick: (docId: number) => void
}

export const sutableImgExtensions = ['PNG', 'JPG', 'JPEG', 'GIF', 'SVG', 'WEBP', 'AVIF']
export const sutableVideoExtensions = ['MP4', 'MOV', 'MPEG', 'WEBM', 'OGG', 'MKV']

export const FilesControl: FC<Props> = ({ docs, selectedFiles, onDocClick, onUpload, uploadProgress }) => {
  const ref = useRef<HTMLInputElement>(null)

  const addFile = () => {
    ref.current?.click()
  }

  return (
    <ImagesWrapper>
      {docs.map((doc) => {
        const seletedIndex = selectedFiles.findIndex((selected) => selected.toString() === doc.id.toString())
        return (
          <FileWrapper key={doc.id} onClick={() => onDocClick(doc.id as number)}>
            <IconContainer>{seletedIndex !== -1 && <Icons.IconDone />}</IconContainer>
            {seletedIndex !== -1 && (
              <NumberContainer>
                <Text typography="titleH1" color="primary">
                  {seletedIndex + 1}
                </Text>
              </NumberContainer>
            )}
            {sutableImgExtensions.includes(doc.extension || '') ? (
              <img width={100} height={100} src={doc.uploaded_file} />
            ) : (
              <FilePlaceholder>
                <Icons.IconDocument />
                <Text typography="bodySmall">{doc.original_filename}</Text>
              </FilePlaceholder>
            )}
          </FileWrapper>
        )
      })}
      {onUpload && (
        <>
          <AddBtn onClick={addFile}>
            <FilePlaceholder>{uploadProgress == Progress.WORK ? <Spinner /> : <AddFileIcon />}</FilePlaceholder>
          </AddBtn>
          <input
            style={{ display: 'none' }}
            type="file"
            ref={ref}
            onChange={(event) => event.target.files && onUpload(event.target.files)}
            multiple
          />
        </>
      )}
    </ImagesWrapper>
  )
}
